/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_EmptyInputs */

const vi_invoice_misa_template_empty = /** @type {(inputs: Invoice_Misa_Template_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có mẫu hóa đơn đang hoạt động trên MISA. Nhờ kế toán kiểm tra mẫu trên MISA rồi bấm Làm mới mẫu từ MISA.`)
};

/**

* @param {Invoice_Misa_Template_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_empty = /** @type {((inputs?: Invoice_Misa_Template_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_empty(inputs)
});